/**
 * Returns the current wall-clock time. Injectable so tests can drive the
 * engine and its subsystems through deterministic schedules without real
 * `setTimeout` games.
 */
export interface Clock {
  now(): Date;
}

export const SYSTEM_CLOCK: Clock = {
  now: () => new Date(),
};

/**
 * Periodic tick driver. Production wraps `setInterval`; tests inject a
 * controllable fake. Subsystems (engine schedule loop, telemetry flush,
 * remote-config poll) all use this — one shared abstraction so a fake
 * scheduler can drive an entire integration test step-by-step.
 */
export interface Ticker {
  /** Begin invoking `onTick` every `intervalMs`. Returns a cancel function. */
  start(onTick: () => void, intervalMs: number): () => void;
}

export const SYSTEM_TICKER: Ticker = {
  start(onTick, intervalMs) {
    const handle = setInterval(onTick, intervalMs);
    return () => {
      clearInterval(handle);
    };
  },
};
